var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/connection/LibreDataShare/LibreDataShareCard/index.tsx";
import React, { useEffect, useState } from 'react';
import { Divider, HStack, LoadingSpinner, Stack, Text } from '@adc/parallax-component-library';
import { useApiError, useLibreDataShare } from 'Hooks';
import { Link } from 'Components/utility';
import { formatDataShareCode } from 'Utilities/dataHelpers';
import { formatTimestamp } from 'Utilities/dateHelpers';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
const LibreDataShareCard = ({
  dataShareConnection
}) => {
  const [hasCode, setHasCode] = useState(!!dataShareConnection);
  const {
    monthDate,
    time
  } = formatTimestamp(dataShareConnection?.expiresAt || 0);
  const [loading, setLoading] = useState(false);
  const {
    createNewDataShare
  } = useLibreDataShare();
  const {
    showApiErrorModal
  } = useApiError();
  useEffect(() => {
    if (!dataShareConnection?.expiresAt) {
      return;
    }
    const msToExpiry = new Date(dataShareConnection.expiresAt * 1000).getTime() - Date.now();
    const timeoutId = setTimeout(() => {
      setHasCode(false);
    }, msToExpiry);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [dataShareConnection?.expiresAt]);
  const handleManageCode = async () => {
    mediator.publish('router:navigate', {
      url: '/lds-connection',
      data: {
        dataShareConnection: dataShareConnection
      }
    });
  };
  const handleCreateCode = async () => {
    try {
      setLoading(true);
      const dataShareConnection = await createNewDataShare();
      mediator.publish('router:navigate', {
        url: '/lds-connection',
        data: {
          dataShareConnection: dataShareConnection
        }
      });
    } catch (err) {
      showApiErrorModal();
    } finally {
      setLoading(false);
    }
  };
  return /*#__PURE__*/React.createElement(Stack, {
    marginTop: "$4",
    padding: "$4",
    backgroundColor: "$surface.container",
    border: "$1.5",
    shadow: "$1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Text, {
    color: "$text.100",
    marginBottom: "$3",
    fontSize: "$h4.strong",
    fontWeight: "$h4.strong",
    testID: "LibreDataShareCard.title",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 78,
      columnNumber: 7
    }
  }, i18n.t('Connections.content.libreDataShareCard.primaryText')), hasCode && dataShareConnection ? /*#__PURE__*/React.createElement(Stack, {
    alignItems: "center",
    marginTop: "$3",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "LibreDataShareCard.code",
    fontSize: "$dataSmall.medium",
    fontWeight: "$dataSmall.medium",
    color: "$text.100",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 11
    }
  }, formatDataShareCode(dataShareConnection.code)), /*#__PURE__*/React.createElement(Text, {
    testID: "LibreDataShareCard.expiresAt",
    fontSize: "$bodySmall.default",
    fontWeight: "$bodySmall.default",
    color: "$text.100",
    marginTop: "$3",
    marginBottom: "$3",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 97,
      columnNumber: 11
    }
  }, i18n.t('Connections.content.libreDataShareCard.bodyText', {
    time,
    monthDate
  }))) : /*#__PURE__*/React.createElement(Text, {
    marginBottom: "$4",
    color: "$text.100",
    fontSize: "$bodyBase.default",
    fontWeight: "$bodyBase.default",
    testID: "LibreDataShareCard.message",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 112,
      columnNumber: 9
    }
  }, i18n.t('Connections.content.libreDataShareCard.secondaryText')), /*#__PURE__*/React.createElement(Divider, {
    marginBottom: "$4",
    borderColor: "$neutral.40",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 122,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(HStack, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 123,
      columnNumber: 7
    }
  }, loading ? /*#__PURE__*/React.createElement(LoadingSpinner, {
    testID: "LibreDataShareCard.createCode.spinner",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 125,
      columnNumber: 11
    }
  }) : hasCode ? /*#__PURE__*/React.createElement(Link, {
    disabled: loading,
    testID: "LibreDataShareCard.createCode-btn",
    onPress: handleManageCode,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 127,
      columnNumber: 11
    }
  }, i18n.t('Connections.content.libreDataShareCard.links.manageCode.label')) : /*#__PURE__*/React.createElement(Link, {
    disabled: loading,
    testID: "LibreDataShareCard.createCode-btn",
    onPress: handleCreateCode,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 135,
      columnNumber: 11
    }
  }, i18n.t('Connections.content.libreDataShareCard.links.linkText.label'))));
};
export default LibreDataShareCard;